var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-t-xl bg-gradient-to-b from-white to-smoke w-full text-darkViolet",class:_vm.isHome === false ? 'px-6 pt-12 ' : null},[_vm._t("header"),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }